import React from 'react';
import { motion } from 'framer-motion';
interface FadeInSectionProps {
  children: ReactNode;
  className?: string;
  delay?: number;
}
export function FadeInSection({
  children,
  className = '',
  delay = 0
}: FadeInSectionProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6,
    delay
  }} className={className} data-id="element-391">
      {children}
    </motion.div>;
}